import { ISeasonPrice } from "src/models/ISeasonPrice";

export class SeasonPrice implements ISeasonPrice {
  location = [] as string[] | "";
  start_date = "";
  end_date = "";
  rate = 0;
}